var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"ui-button ui-button-primary",class:{ 'ui-button-primary-focus': _setup.focus },on:{"click":() => _setup.emit('click')}},[_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }